import * as XLSX from 'xlsx';

/**
 * exportToExcel
 * @param {string} filename  — output filename (without .xlsx)
 * @param {Array}  sheets    — array of { name, headers, rows, colWidths? }
 *   headers   : string[]              — column header labels
 *   rows      : any[][]               — 2D array of cell values
 *   colWidths : number[]  (optional)  — column widths in characters
 */
export function exportToExcel(filename, sheets) {
  const wb = XLSX.utils.book_new();
  wb.Props = { Title: filename, CreatedDate: new Date() };

  for (const { name, headers, rows, colWidths } of sheets) {
    const data = [headers, ...rows];
    const ws = XLSX.utils.aoa_to_sheet(data);

    // Bold-style the header row via cell styling (community edition supports basic styles)
    headers.forEach((_, ci) => {
      const cellAddr = XLSX.utils.encode_cell({ r: 0, c: ci });
      if (ws[cellAddr]) ws[cellAddr].s = { font: { bold: true } };
    });

    if (colWidths) {
      ws['!cols'] = colWidths.map(w => ({ wch: w }));
    } else {
      // Auto-width: max of header length vs sample row values
      ws['!cols'] = headers.map((h, i) => ({
        wch: Math.max(
          h.length,
          ...rows.slice(0, 20).map(r => String(r[i] ?? '').length),
          12
        ),
      }));
    }

    XLSX.utils.book_append_sheet(wb, ws, name.slice(0, 31));
  }

  XLSX.writeFile(wb, `${filename}.xlsx`);
}

/** Format a date string to readable IST */
export function fmtDateIST(d) {
  if (!d) return '';
  let s = String(d);
  if (!s.endsWith('Z') && !s.includes('+')) s += 'Z';
  return new Date(s).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false,
  });
}

/** Numeric formatter */
export function fmtNum(v, dec = 2) {
  if (v == null || v === '') return '';
  return Number(v).toFixed(dec);
}
